import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      "company name": "CFD-I Punto",
      "company email": "cfdipunto@hotmail.com",
      "certificate valid until": "certificate valid until",
      "phone company": "55 6363 7044",
      activity: "activity",
      profile: "profile",
      login: "login",
      "sign into": "Sign In to your account",
      "bills available": "available folios",
      username: "username",
      password: "password",
      save: "save",
      submit: "submit",
      "forgot password": "forgot password",
      home: "home",
      name: "name",
      lastname: "lastname",
      about: "about",
      services: "services",
      security: "security",
      portafolio: "portafolio",
      contact: "contact",
      "useful links": "useful links",
      "our services": "our services",
      "contact us": "contact us",
      email: "email",
      review: "review",
      "terms of service": "terms of service",
      "privacy policy": "privacy policy",
      "internal links": "internal links",
      application: "application",
      "my profile": "my profile",
      "your profile": "my profile",
      "account settings": "account settings",
      "sign out": "sign out",
      clients: "clients",
      "list clients": "list clients",
      billing: "billing",
      reports: "reports",
      "purchased package": "purchased package",
      "package name": "package name",
      "requested date": "requested date",
      "requested by": "requested by",
      "quantity tickets": "quantity tickets",
      "approved by": "approved by",
      "last update": "last update",
      "tickets available": "tickets available",
      filter: "tickets available",
      today: "today",
      available: "disponible",
      "this month": "this month",
      "this year": "this year",
      billings: "billings",
      "check the file": "check the file",
      contacts: "contactos",
      businessName: "bussiness name",
      street: "street",
      exterior: "exterior",
      interior: "interior",
      suburb: "suburb",
      town: "town",
      state: "state",
      postalCode: "postal code",
      phone: "telephone",
      "package adquired": "package adquired",
      "buy package": "buy package",
      "update contact": "update contact",
      id: "id",
      "quantity folios": "quantity folios",
      "requested ago": "requested ago",
      "last modification": "last modification",
      "requested by company": "requested by company",
      "requested by who": "requested by who",
      actions: "actions",
      "login.invalid_credentials": "Invalid username or password",
      "login.user_inactive": "User not active",
      "login.temporal_failure":
        "Temporal failure, please try again later. If the problem persists, contact the administrator.",
      "login.unexpected_error":
        "Unexpected error, please try again later. If the problem persists, contact the administrator.",
      emailContact: "email contact",
      requested: "requested",
      "requested to": "requested to",
      type: "tax regime type",

      // ── Bloque T: navegación, títulos y textos por perfil ─────────────────
      // La BD no cambia: Company/Contact sólo se muestran con otro nombre
      // según el perfil (usuario = "user"/"client", contador = "issuer"/"receiver").
      nav: {
        home: "home",
        profile: "profile",
        folios: "folios",
        foliosPurchased: "purchased folios",
        bills: "bills",
        billsDetail: "issued detail",
        internalUsers: "users",
        settings: "settings",
        notifications: "notifications",
        sentEmails: "sent emails",
        packagesAdmin: "packages",
        mcp: "MCP",
        impersonate: "impersonate user",
        issuer: "issuer",
        issuerData: "issuer data",
        receiver: "receiver",
        receiverData: "receiver data",
        account: "user",
        accountData: "user data",
        clients: "client list",
        clientsList: "clients",
        requestBill: "request your invoice",
        requestedBills: "requested invoices",
        packages: "packages",
        packagesDetail: "package detail",
        packagesBuy: "buy a package",
      },
      page: {
        home: "Home",
        myProfile: "My profile",
        requestedBills: "Requested invoices",
        requestBill: "Request your invoice",
        billDetail: "Invoice detail",
        clients: "Client list",
        clientsToBill: "Client list to invoice",
        clientCreate: "Create a client to invoice",
        clientEdit: "Edit a client to invoice",
        clientShow: "Client and its requested invoices",
        account: "User",
        accountData: "User data",
        accountEdit: "Edit user data",
        accountShow: "User detail",
        fiscalDocuments: "Upload your tax documents",
        fiscalDocumentsCrumb: "Tax documents",
        issuers: "Issuers",
        issuerData: "Issuer data",
        issuerList: "Issuer list",
        receivers: "Receivers",
        receiverList: "Receiver list",
      },
      ui: {
        cancel: "Cancel",
        folioExpiry: {
          soon_one: "1 folio you have not used expires in {{days}} days",
          soon_other:
            "{{count}} folios you have not used expire in {{days}} days",
          tomorrow_one: "1 folio you have not used expires tomorrow",
          tomorrow_other: "{{count}} folios you have not used expire tomorrow",
          detail:
            "They expire on {{date}}. The invoices you already requested, and their CFDI, are kept.",
        },
        quota: {
          advisoriesTitle: "Tax advisory sessions",
          consultationsTitle: "Formal consultations",
          remaining_one: "1 left",
          remaining_other: "{{count}} left",
          expiresOn: "Available until {{date}}",
          askByWhatsapp: "Ask on WhatsApp",
          channelPending: "Channel not set up yet",
          advisoriesMessage:
            "Hello, I am a CFD-IPunto customer and I would like to use one of my tax advisory sessions.",
          consultationsMessage:
            "Hello, I am a CFD-IPunto customer and I would like to make a formal tax consultation.",
          register: {
            title: "Sessions attended",
            hint: "Register it when you finish. Opening a WhatsApp chat does not count.",
            advisories: "Register advisory attended",
            consultations: "Register consultation attended",
            noteLabel: "What was it about?",
            notePlaceholder: "In short",
            confirm: "Register",
            done: "Registered",
            notDone: "Not registered",
            notDoneHint: "It could not be registered. Try again.",
          },
        },
        priorityAttention: "Priority attention",
        fiscalCertificate: "Tax status certificate",
        complianceOpinion: "Tax compliance opinion (32/D)",
        updatedOn: "Updated on {{date}}",
        pendingFromAccountant: "Pending from your accountant",
        askYourAccountant: "Ask your accountant",
        download: "Download",
        loading: "Loading…",
        noDocumentsYet: "Nothing delivered yet.",
        version: "Version",
        uploadedAgo: "Uploaded",
        exactDate: "Exact date",
        complianceStatus: "Opinion",
        uploadedBy: "Uploaded by",
        file: "File",
        current: "Current",
        compliance: {
          positivo: "Positive",
          negativo: "Negative",
          sin_determinar: "Undetermined",
        },
        uploadFiscalCertificate: "Upload tax status certificate",
        uploadComplianceOpinion: "Upload 32/D compliance opinion",
        uploadNew: "Upload a new {{document}}.",
        dropHere: "Drop the file here…",
        uploadedWithWarning: "Saved, but they will not see it",
        uploadFailed: "Could not upload the {{document}}",
        uploadFailedHint: "Check that the document is a current, valid PDF.",
        complianceProposedTitle: "Confirm the opinion",
        complianceProposedText:
          "The system read the PDF and proposes: {{status}}. Confirm it or correct it.",
        confirm: "Confirm",

        welcome:
          "Welcome to CFD-IPunto. Your professional tool to manage digital tax receipts with backup and confidence.",
        requestedBillsList: "Requested invoice list",
        newClient: "New client",
        requestBill: "Request your invoice",
        createClient: "Create client",
        clientDeletedTitle: "Client removed",
        clientDeleted:
          "The client is no longer on your list. If it had invoices, they are kept and can still be downloaded.",
        clientDeleteWarning:
          "It will no longer appear when you request an invoice. Invoices you already issued to this client are kept.",
        clientDeleteError: "There was a problem deleting the client.",
        clientCreateError: "The client could not be created.",
        clientLoadError: "The client information could not be loaded.",
        clientDetail: "Client detail",
        emptyClients: "There are no registered clients",
        noClientsHint:
          "You have no clients registered. Create one in the Clients section.",
        generateAccount: "Generate your user",
        enterYourData: "Enter your details",
        registerAccount: "Register your user",
        createAccount: "Create user",
        editAccount: "Edit user",
        editAccountHint: "Update your tax data.",
        accountUpdated: "User updated",
        accountLoadError: "The user could not be loaded.",
        accountNotFound: "User not found.",
        accountCreateError:
          "The user could not be created. Check the data and try again.",
        accountParsedHint:
          "Review and complete the data before creating your user.",
        accountFirstHint: "First generate your user to buy packages.",
        accountNeededTitle: "Generate your user first",
        accountNeededText: "You need your user in order to request invoices.",
        selectAccount: "Select your user...",
        selectAccountLabel: "User the invoice will be issued with",
        selectAccountRequired:
          "You must select the user the invoice will be issued with.",
        selectClientLabel:
          "The invoice will be issued to the Client (Tax ID / Legal name)",
        selectClientRequired: "You must select a client from the list.",
        issuerDeleted: "The issuer has been deleted.",
        issuerDeleteError: "The issuer could not be deleted.",
        issuerActions: "Issuer actions",
        createIssuer: "Create issuer",
        issuers: "Issuers",
      },
      // ── Catálogo de paquetes: todo sale de GET /packages ──────────────────
      packages: {
        title: "Packages",
        loading: "Loading packages…",
        loadError: "The packages could not be loaded. Try again in a moment.",
        select: "Select a package",

        // Tarjetas — textos del catálogo del cliente
        folios_one: "{{count}} digital folio",
        folios_other: "{{count}} digital folios",
        perFolio: "{{price}} / folio",
        validityUnlimited: "Folio validity: UNLIMITED",
        validityYears_one: "Folio validity: {{count}} year",
        validityYears_other: "Folio validity: {{count}} years",
        validityMonths_one: "Folio validity: {{count}} month",
        validityMonths_other: "Folio validity: {{count}} months",
        attention: "Personal support",
        attentionPriority: "Priority support",
        cfdiKept: "Your CFDI (PDF and XML) are kept for good",
        storage: "Business storage",
        priorityAttention: "Priority attention",
        fiscalCertificate: "Tax status certificate",
        complianceOpinion: "Tax compliance opinion",
        history: "Operations history",
        advisories: "Tax advisories",
        advisoriesCount: "{{count}} tax advisories",
        consultations: "Tax or accounting consultations",
        consultationsCount: "{{count}} tax or accounting consultations",
        savings: "Save {{percent}}%",
        bonus: "Pay {{paid}}, get {{credited}}",
        ribbonNoExpiry: "No longer expires",
        ribbonBonus: "+{{count}} free",
        ribbonAll: "Everything included",
        newInPlan: "New in this plan",
        hire: "Get started",
        paySpei: "Pay by SPEI",
        payCard: "Pay by card",
        payCardSoon: "Coming soon",
        payTransfer: "Already transferred? Upload your receipt",
        opening: "Opening payment…",
        checkoutError:
          "The payment could not be opened. Please try again shortly.",
        close: "Close",
        seeSpeiReference: "See my SPEI reference",
        speiPendingTitle: "You have a SPEI reference to pay",
        speiPendingText:
          "Your {{name}} is waiting for the SPEI payment. You have until {{date}}; once it arrives, your folios are credited automatically.",
        resultWaiting: "Confirming your payment…",
        resultWaitingLong:
          "Your payment is being processed. Once confirmed your folios are credited and you get an email; no need to wait here.",
        resultPaid: "Done! {{count}} folios from your {{name}} were credited.",
        resultSpei:
          "Your SPEI reference is ready. Pay it from your bank before {{date}}: folios are credited automatically when the payment arrives.",
        resultFailed:
          "The payment was not completed and nothing was charged. You can try again.",
        resultExpired: "This payment expired without being completed.",
        backToPackages: "Back to packages",
        goHome: "Go home",
        speiHelp:
          "Transfer by SPEI and upload your receipt: folios are credited once the accountant validates it.",

        // Vigencia en una sola palabra (calculadora de la portada)
        valueUnlimited: "UNLIMITED",
        valueYears_one: "{{count}} year",
        valueYears_other: "{{count}} years",
        valueMonths_one: "{{count}} month",
        valueMonths_other: "{{count}} months",

        // Preguntas frecuentes
        faqTitle: "Before you decide",
        faqSubtitle: "The questions we get most often.",
        faq1Q: "Do my folios expire?",
        faq1A:
          "It depends on the package. Packages {{limited}} are valid for 1 year. Packages {{unlimited}} never expire: use them whenever you need. Invoices already issued are kept; what expires are the folios you did not use.",
        faq2Q: "How long can I download my CFDI?",
        faq2A:
          "In every package your issued invoices are kept. What expires, in packages {{limited}}, are the folios you did not use.",
        faq3Q: "What do I get with Package {{package}}?",
        faq3A:
          "You pay {{price}} for {{paid}} folios and get {{credited}}. This is where business storage, operations history and {{advisories}} tax advisories start.",
        faq4Q: "Which one suits me?",
        faq4A:
          "If you issue few invoices a year, Package {{small}}. If you invoice regularly, Package {{unlimited}} and up costs less per folio and never expires.",
      },
    },
  },
  es: {
    translation: {
      "company name": "CFD-I Punto",
      "phone company": "55 6363 7044",
      "company email": "cfdipunto@hotmail.com",
      "certificate valid until": "Vigencia del certificado",
      activity: "actividad",
      profile: "perfil",
      login: "iniciar sesión",
      "sign into": "Ingresa a tu cuenta",
      username: "nombre de usuario",
      password: "contraseña",
      submit: "enviar",
      save: "guardar",
      "forgot password": "olvidaste la contraseña",
      home: "inicio",
      name: "nombre",
      lastname: "apellido",
      about: "acerca",
      services: "servicios",
      security: "seguridad",
      portafolio: "portafolio",
      contact: "contacto",
      "useful links": "links",
      "our services": "nuestros servicios",
      "contact us": "contactanos",
      email: "email",
      "terms of service": "términos del servicio",
      "privacy policy": "política de privacidad",
      "internal links": "links internos",
      application: "aplicación",
      "my profile": "mi perfil",
      "your profile": "tu perfil",
      "account settings": "ajustes de la cuenta",
      "sign out": "salir",
      "company type": "tipo de persona",
      clients: "clientes",
      "date of birth": "dia de nacimiento",
      "telephone contact": "teléfono",
      "list clients": "lista de clientes",
      billing: "facturas",
      reports: "reportes",
      review: "revisar",
      "purchased package": "paquete comprado",
      "package name": "nombre del paquete",
      "requested date": "fecha solicitud",
      "requested by": "solicitado por",
      "quantity tickets": "numero de tickets",
      "approved by": "aprobado por",
      "last update": "ultima actualización",
      "tickets available": "tickets disponible",
      filter: "filtros",
      available: "disponible",
      today: "hoy",
      "this month": "este mes",
      "this year": "este año",
      billings: "facturas",
      "check the file": "revisa el archivo",
      "bills available": "folios disponibles",
      taxIdentification: "RFC",
      businessName: "razón social",
      street: "calle",
      exterior: "exterior",
      interior: "interior",
      suburb: "colonia",
      town: "municipio / alcaldía",
      state: "estado",
      postalCode: "código postal",
      "postal code": "código postal",
      phone: "teléfono",
      "update contact": "actualizar contacto",
      "package adquired": "paquete adquirido",
      "buy package": "comprar paquete",
      "quantity bills": "folios solicitados",
      id: "ID solicitud",
      "quantity folios": "cantidad de folios",
      "requested ago": "solicitada hace",
      "last modification": "última actualización",
      "requested by company": "empresa",
      "requested by who": "solicitante",
      actions: "acciones",
      "login.invalid_credentials": "Usuario o contraseña incorrectos",
      "login.user_inactive": "Usuario inactivo",
      "login.temporal_failure":
        "Fallo temporal, por favor intente de nuevo más tarde. Si el problema persiste, contacte al administrador.",
      "login.unexpected_error":
        "Error inesperado, por favor intente de nuevo más tarde. Si el problema persiste, contacte al administrador.",
      emailContact: "correo de contacto",
      requested: "solicitada hace",
      "requested to": "receptor",
      folio: "folio",
      company: "emisor",
      status: "estatus",
      type: "tipo de régimen fiscal",

      // ── Bloque T: navegación, títulos y textos por perfil ─────────────────
      // La BD no cambia: Company/Contact sólo se muestran con otro nombre
      // según el perfil (usuario = "usuario"/"cliente", contador = "emisor"/"receptor").
      nav: {
        home: "inicio",
        profile: "perfil",
        folios: "folios",
        foliosPurchased: "folios comprados",
        bills: "facturas",
        billsDetail: "detalle generadas",
        internalUsers: "usuarios",
        settings: "configuraciones",
        notifications: "notificaciones",
        sentEmails: "correos enviados",
        packagesAdmin: "paquetes",
        mcp: "MCP",
        impersonate: "suplantar usuario",
        issuer: "emisor",
        issuerData: "datos del emisor",
        receiver: "receptor",
        receiverData: "datos del receptor",
        account: "usuario",
        accountData: "datos del usuario",
        clients: "lista de clientes",
        clientsList: "clientes",
        requestBill: "solicita tu factura",
        requestedBills: "facturas solicitadas",
        packages: "paquetes",
        packagesDetail: "detalle de paquetes",
        packagesBuy: "compra un paquete",
      },
      page: {
        home: "Inicio",
        myProfile: "Mi perfil",
        requestedBills: "Facturas solicitadas",
        requestBill: "Solicita tu factura",
        billDetail: "Detalle de la factura",
        clients: "Lista de clientes",
        clientsToBill: "Lista de clientes para facturar",
        clientCreate: "Crea un cliente para facturar",
        clientEdit: "Edita un cliente para facturar",
        clientShow: "Cliente y sus facturas solicitadas",
        account: "Usuario",
        accountData: "Datos del usuario",
        accountEdit: "Editar datos del usuario",
        accountShow: "Detalle del usuario",
        fiscalDocuments: "Sube tus documentos fiscales",
        fiscalDocumentsCrumb: "Documentos fiscales",
        issuers: "Emisores",
        issuerData: "Datos del emisor",
        issuerList: "Lista de emisores",
        receivers: "Receptores",
        receiverList: "Lista de receptores",
      },
      ui: {
        cancel: "Cancelar",
        folioExpiry: {
          soon_one: "1 folio sin usar caduca en {{days}} días",
          soon_other: "{{count}} folios sin usar caducan en {{days}} días",
          tomorrow_one: "1 folio sin usar caduca mañana",
          tomorrow_other: "{{count}} folios sin usar caducan mañana",
          detail:
            "Vencen el {{date}}. Las facturas que ya pediste, y sus CFDI, se conservan.",
        },
        quota: {
          advisoriesTitle: "Asesorías fiscales",
          consultationsTitle: "Consultas formales",
          remaining_one: "Te queda 1",
          remaining_other: "Te quedan {{count}}",
          expiresOn: "Disponibles hasta el {{date}}",
          askByWhatsapp: "Consultar por WhatsApp",
          channelPending: "Canal aún no configurado",
          advisoriesMessage:
            "Hola, soy cliente de CFD-IPunto y quiero usar una de mis asesorías fiscales.",
          consultationsMessage:
            "Hola, soy cliente de CFD-IPunto y quiero hacer una consulta fiscal formal.",
          register: {
            title: "Atenciones dadas",
            hint: "Regístrala al terminar. Que el usuario abra WhatsApp no cuenta.",
            advisories: "Registrar asesoría atendida",
            consultations: "Registrar consulta atendida",
            noteLabel: "¿De qué fue?",
            notePlaceholder: "En corto",
            confirm: "Registrar",
            done: "Registrada",
            notDone: "No se registró",
            notDoneHint: "No se pudo registrar. Inténtalo de nuevo.",
          },
        },
        priorityAttention: "Atención prioritaria",
        fiscalCertificate: "Constancia de situación fiscal",
        complianceOpinion: "Opinión de cumplimiento 32/D",
        updatedOn: "Actualizada el {{date}}",
        pendingFromAccountant: "Pendiente de tu contador",
        askYourAccountant: "Consulta a tu contador",
        download: "Descargar",
        loading: "Cargando…",
        noDocumentsYet: "Todavía no se ha entregado ninguno.",
        version: "Versión",
        uploadedAgo: "Subido",
        exactDate: "Fecha exacta",
        complianceStatus: "Sentido de la opinión",
        uploadedBy: "Lo subió",
        file: "Archivo",
        current: "Vigente",
        compliance: {
          positivo: "Positiva",
          negativo: "Negativa",
          sin_determinar: "Sin determinar",
        },
        uploadFiscalCertificate: "Subir constancia fiscal",
        uploadComplianceOpinion: "Subir 32/D",
        uploadNew: "Sube una nueva {{document}}.",
        dropHere: "Suelta el archivo aquí…",
        uploadedWithWarning: "Se guardó, pero no la verá",
        uploadFailed: "No se pudo subir la {{document}}",
        uploadFailedHint:
          "Verifica que el documento sea un PDF actual y válido.",
        complianceProposedTitle: "Confirma el sentido de la opinión",
        complianceProposedText:
          "El sistema leyó el PDF y propone: {{status}}. Confírmalo o corrígelo.",
        confirm: "Confirmar",

        welcome:
          "Bienvenido a CFD-IPunto. Tu herramienta profesional para gestionar comprobantes fiscales digitales con respaldo y confianza.",
        requestedBillsList: "Lista de facturas solicitadas",
        newClient: "Nuevo cliente",
        requestBill: "Solicita tu factura",
        createClient: "Crear cliente",
        clientDeletedTitle: "Cliente quitado",
        clientDeleted:
          "El cliente ya no aparece en tu lista. Si tenía facturas, se conservan y las puedes seguir descargando.",
        clientDeleteWarning:
          "Dejará de aparecer cuando solicites una factura. Las facturas que ya le emitiste se conservan.",
        clientDeleteError: "Hubo un problema al borrar el cliente.",
        clientCreateError: "Error al crear el cliente.",
        clientLoadError: "No se pudo cargar la información del cliente.",
        clientDetail: "Detalle del cliente",
        emptyClients: "No hay clientes registrados",
        noClientsHint:
          "No tienes clientes registrados. Crea uno en la sección de Clientes.",
        generateAccount: "Genera tu usuario",
        enterYourData: "Ingresa tus datos",
        registerAccount: "Registra tu usuario",
        createAccount: "Crear usuario",
        editAccount: "Editar usuario",
        editAccountHint: "Actualiza tus datos fiscales.",
        accountUpdated: "Usuario actualizado",
        accountLoadError: "No se pudo cargar el usuario.",
        accountNotFound: "Usuario no encontrado.",
        accountCreateError:
          "No se pudo crear el usuario. Verifica los datos e intenta de nuevo.",
        accountParsedHint:
          "Revisa y completa los datos antes de crear tu usuario.",
        accountFirstHint: "Primero genera tu usuario para comprar paquetes.",
        accountNeededTitle: "Genera tu usuario primero",
        accountNeededText: "Necesitas tu usuario para solicitar facturas.",
        selectAccount: "Selecciona tu usuario...",
        selectAccountLabel: "Usuario con el que se facturará",
        selectAccountRequired:
          "Debes seleccionar el usuario con el que se facturará.",
        selectClientLabel:
          "La factura se generará al Cliente (RFC / Razón Social)",
        selectClientRequired: "Debes seleccionar un cliente de la lista.",
        issuerDeleted: "El emisor ha sido eliminado.",
        issuerDeleteError: "No se pudo eliminar el emisor.",
        issuerActions: "Acciones de emisor",
        createIssuer: "Crear emisor",
        issuers: "Emisores",
      },
      // ── Catálogo de paquetes: todo sale de GET /packages ──────────────────
      packages: {
        title: "Paquetes",
        loading: "Cargando paquetes…",
        loadError:
          "No se pudieron cargar los paquetes. Intenta de nuevo en un momento.",
        select: "Selecciona un paquete",

        // Tarjetas — textos del catálogo del cliente
        folios_one: "{{count}} folio digital",
        folios_other: "{{count}} folios digitales",
        perFolio: "{{price}} / folio",
        validityUnlimited: "Vigencia de folios: ILIMITADA",
        validityYears_one: "Vigencia de folios: {{count}} año",
        validityYears_other: "Vigencia de folios: {{count}} años",
        validityMonths_one: "Vigencia de folios: {{count}} mes",
        validityMonths_other: "Vigencia de folios: {{count}} meses",
        attention: "Atención personalizada",
        attentionPriority: "Atención Prioritaria",
        cfdiKept: "Tus CFDI (PDF y XML) se conservan siempre",
        storage: "Almacenamiento Empresarial",
        fiscalCertificate: "Constancia de Situación Fiscal",
        complianceOpinion: "Cumplimiento de Obligaciones Fiscales",
        history: "Historial de operaciones",
        advisories: "Asesorías Fiscales",
        advisoriesCount: "{{count}} Asesorías Fiscales",
        consultations: "Consultas Fiscales o Contables",
        consultationsCount: "{{count}} Consultas Fiscales o Contables",
        savings: "Ahorra {{percent}}%",
        bonus: "Pagas {{paid}}, recibes {{credited}}",
        ribbonNoExpiry: "Ya no caduca",
        ribbonBonus: "+{{count}} gratis",
        ribbonAll: "Todo incluido",
        newInPlan: "Nuevo en este plan",
        hire: "Contratar",
        paySpei: "Pagar por SPEI",
        payCard: "Pagar con tarjeta",
        payCardSoon: "Disponible próximamente",
        payTransfer: "¿Ya transferiste? Sube tu comprobante",
        opening: "Abriendo el pago…",
        checkoutError:
          "No se pudo abrir el pago. Intenta de nuevo en un momento.",
        close: "Cerrar",
        seeSpeiReference: "Ver mi referencia SPEI",
        speiPendingTitle: "Tienes una referencia SPEI por pagar",
        speiPendingText:
          "Tu {{name}} está esperando el pago por SPEI. Tienes hasta el {{date}}; en cuanto llegue, tus folios se acreditan solos.",
        resultWaiting: "Estamos confirmando tu pago…",
        resultWaitingLong:
          "Tu pago se está procesando. En cuanto se confirme se acreditan tus folios y te llega un correo; no hace falta que esperes aquí.",
        resultPaid: "¡Listo! Se acreditaron {{count}} folios de tu {{name}}.",
        resultSpei:
          "Tu referencia SPEI está lista. Págala desde tu banca antes del {{date}}: los folios se acreditan solos cuando llegue el pago.",
        resultFailed:
          "El pago no se completó y no se hizo ningún cargo. Puedes intentarlo de nuevo.",
        resultExpired: "Este pago venció sin completarse.",
        backToPackages: "Volver a los paquetes",
        goHome: "Ir al inicio",
        speiHelp:
          "Transfiere por SPEI y sube tu comprobante: tus folios se acreditan cuando el contador lo valida.",

        // Vigencia en una sola palabra (calculadora de la portada)
        valueUnlimited: "ILIMITADA",
        valueYears_one: "{{count}} año",
        valueYears_other: "{{count}} años",
        valueMonths_one: "{{count}} mes",
        valueMonths_other: "{{count}} meses",

        // Preguntas frecuentes
        faqTitle: "Antes de decidir",
        faqSubtitle: "Las dudas que nos hacen más seguido.",
        faq1Q: "¿Mis folios caducan?",
        faq1A:
          "Depende del paquete. Los paquetes {{limited}} tienen vigencia de 1 año. Los paquetes {{unlimited}} son de vigencia ilimitada: los usas cuando los necesites. Tus facturas ya emitidas se conservan; lo que vence son los folios que no usaste.",
        faq2Q: "¿Por cuánto tiempo puedo descargar mis CFDI?",
        faq2A:
          "En todos los paquetes tus facturas ya emitidas se conservan. Lo que vence, en los paquetes {{limited}}, son los folios que no usaste.",
        faq3Q: "¿Qué me llevo con el Paquete {{package}}?",
        faq3A:
          "Pagas {{price}} por {{paid}} folios y recibes {{credited}}. Es el punto donde entran el Almacenamiento Empresarial, el historial de operaciones y {{advisories}} asesorías fiscales.",
        faq4Q: "¿Cuál me conviene?",
        faq4A:
          "Si emites pocas facturas al año, el Paquete {{small}}. Si facturas de forma constante, el Paquete {{unlimited}} en adelante te sale más barato por folio y ya no caduca.",
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "es",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
